<template>
  <div class="gm-page pa-4">
    <PageTop :menus="['告警信息', '数据分析']" />
    <div class="flex-grow-1  d-flex flex-column  overflow-auto mt-4" style="min-height: 0;scrollbar-gutter: stable;">
      <div class="d-flex ga-4 flex-grow-1" style="">
        <div style="flex: 2;" class="d-flex flex-column ">
          <Tasks :fetchOrderList="fetchOrderList" />

          <v-card variant="flat" class="d-flex flex-column flex-grow-1 gm-card mt-4 px-4 om-workorder-card" rounded="xl"
            title="工单" :loading="orderLoading">
            <div class="om-table-wrap">
              <div class="om-table-inner">
                <v-table density="compact" class="bg-transparent flex-grow-1 gm-table om-table">
                  <thead>
                    <tr>
                      <th>设备名称</th>
                      <th>设备类型</th>
                      <th>故障码</th>
                      <th>故障描述</th>
                      <th>故障等级</th>
                      <th>工单状态</th>
                      <th>工单类型</th>
                      <th>创建时间</th>
                      <th>操作</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="order in orderList" :key="order._id">
                      <td>{{ order.eblock_name }}</td>
                      <td>{{ order.equip_type }}</td>
                      <td>{{ order.fault_code }}</td>
                      <td>{{ order.fault_desc }}</td>
                      <td> <v-chip color="var(--color-primary)" rounded>{{ order.fault_level }}</v-chip></td>
                      <td>{{ order.order_status }}</td>
                      <td>{{ order.order_type }}</td>
                      <td>{{ dayjs(order.createTime).format('YYYY-MM-DD HH:mm:ss') }}</td>
                      <td><v-btn variant="text" color="var(--color-primary)" rounded
                          @click="onOpenOrderDetail(order)">详情</v-btn></td>
                    </tr>
                  </tbody>
                </v-table>
              </div>
            </div>

            <div v-if="orderList.length === 0" class="empty-tip text-center py-8 text-medium-emphasis">
              {{ searchKeyword ? '未找到匹配的电站' : '暂无电站数据' }}
            </div>
            <TablePagination :total="total" :pageSize="pageSize" v-model="page" @change="() => fetchOrderList()" />

          </v-card>
        </div>
        <div style="flex: 1;display: flex;flex-direction: column;" class="workbench-right">
          <v-card variant="flat" class="gm-card" rounded="xl" title="电站概况">
            <template #title>
              <div class="d-flex">
                <span>电站概况</span>
              </div>
            </template>
            <div
              class="d-flex flex-wrap gap-4 justify-space-between pa-4 ticket-card ma-4 rounded-lg station-overview-stats"
              style="height: 140px;">
              <DataCard title="电站总数" unit="个" :value="totalStationNum" value-style="font-size: 30px" />
              <DataCard title="已投运" unit="个" :value="staticData.station?.putInto" value-style="font-size: 30px" />
              <DataCard style="cursor: pointer;" @click="goStationsByStatus('building')" title="未投运" unit="个"
                :value="staticData.station?.notPutInto" value-style="font-size: 30px" />
              <DataCard title="暂停运营" unit="个" :value="staticData.station?.stopPutInto" value-style="font-size: 30px" />
            </div>
          </v-card>

          <v-card variant="flat" class="gm-card mt-4 om-todo-card" rounded="xl" title="电站申请" :loading="omTodoLoading">
            <template #title>
              <div class="d-flex align-center">
                <span>电站申请</span>
              </div>
            </template>

            <div class="gm-border pa-2 rounded ma-4 mt-2 om-todo-list">
              <div v-if="!omTodoLoading && !omTodoList.length" class="om-todo-empty text-medium-emphasis">
                暂无数据
              </div>
              <el-carousel v-else :interval="5000" height="288px" direction="horizontal" arrow="never">
                <el-carousel-item v-for="(tasks, gi) in groupedOmTodoList" :key="gi">
                  <div class="om-todo-item" v-for="(task, idx) in tasks" :key="task.id || idx">
                    <div class="om-todo-icon">
                      <img :src="todoReportIcon" alt="">
                    </div>
                    <div class="om-todo-info text-grey-darken-2">
                      {{ getOmTodoText(task) }}
                    </div>
                    <div class="om-todo-time">
                      {{ formatOmTodoTime(task.applyTime) }}
                    </div>
                    <div class="om-todo-actions">
                      <v-btn variant="text" color="var(--color-primary)" rounded
                        @click.stop="onOpenOmTodoDetail(task)">详情</v-btn>
                    </div>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </v-card>

          <v-card variant="flat" class="gm-card gm-card--alarm mt-4" rounded="xl" title="告警">
            <template #title>
              <div class="d-flex">
                <span>告警</span>
              </div>
            </template>
            <div class="d-flex flex-wrap gap-4 justify-space-between gm-border ma-4 mt-2 rounded-lg">
              <div class="alarm-total">
                <DataCard class="alarm-total-card" title="告警总数" unit="个" :value="totalAlarmNum"
                  :value-style="{ ...valueStyle, color: '#fff' }" />
                <img src="./icon-alarm.png">
              </div>
              <div style="display: grid; grid-template-columns: repeat(2, 1fr); flex:1;gap: 12px;padding: 12px;">
                <DataCard class="ticket-card ticket-card--alarm" title="严重故障" unit="个"
                  :value="staticData.alarm?.seriousFaultNum" :value-style="{ fontSize: '22px', color: '#FF5227' }" />
                <DataCard class="ticket-card ticket-card--alarm" title="故障" unit="个" :value="staticData.alarm?.faultNum"
                  :value-style="{ fontSize: '22px', color: '#F6910A' }" />
                <DataCard class="ticket-card ticket-card--alarm" title="告警" unit="个" :value="staticData.alarm?.alarmNum"
                  :value-style="{ fontSize: '22px', color: '#F4C10B' }" />
                <DataCard class="ticket-card ticket-card--alarm" title="提示" unit="个"
                  :value="staticData.alarm?.promptNum" :value-style="{ fontSize: '22px', color: '#2E2E2E80' }" />
              </div>
            </div>
          </v-card>

          <v-card v-if="false" variant="flat" class="gm-card mt-4 flex-fill" rounded="xl" title="常用工具">
            <div class="d-flex align-center justify-space-between pl-4">常见问题库(FAQ)
              <v-tabs v-model="activeTab" color="#426CF9" density="compact" rounded="xl">
                <v-tab :value="tab.value" v-for="tab in tabs" :key="tab.value">{{ tab.name }}</v-tab>
              </v-tabs>
            </div>
            <div style="height: 100%;" class="gm-border ma-4 mt-2 rounded-lg pa-4 d-flex flex-column ga-2">
              <a class="faq-item">电站SOC过低怎么办?</a>
              <a class="faq-item">设备离线如何处理?</a>
              <a class="faq-item">充放电功率异常原因？</a>
              <a class="faq-item">电价配置错误怎么修改？</a>
              <a class="faq-item">数据不更新如何排查?</a>
            </div>
            <div class="gm-border ma-4 mt-2 rounded-lg d-flex faq-question">
              <input type="text" value="数据不更新如何排查" class="faq-question-input" placeholder="请输入问题描述">
              <v-btn density="compact" variant="tonal" color="var(--color-primary)" rounded="xl" :icon="Send"></v-btn>
            </div>
          </v-card>
        </div>
      </div>
    </div>
  </div>

  <v-dialog v-model="dialogVisible" width="500">
    <v-card title="工单详情" class="px-4 gm-dialog-card">
      <DataCardPropsProvide :value-style="{ 'font-size': '16px', 'font-weight': 'bold' }" title-position="left">
        <DataCard title="工单ID" :value="orderDetail._id" />
        <DataCard title="电站名称" :value="orderDetail.station_name || 'N/A'" />
        <DataCard title="故障详情" :value="orderDetail.fault_detail" />
        <DataCard title="创建人" :value="orderDetail.creator?.name || 'N/A'" />
      </DataCardPropsProvide>
      <v-card-actions>
        <v-btn color="var(--color-primary)" rounded="xl" @click="dialogVisible = false">关闭</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>
<script setup>
import { ref, computed } from 'vue'
import PageTop from '@/components/PageTop/index.vue'
import Tasks from '../components/Tasks/index.vue'
import DataCardPropsProvide from '@/components/DataCard/PropProvide.vue'
import DataCard from '@/components/DataCard/index.vue'
import { Send } from 'lucide-vue-next'
import * as api from '@/api/workbench/it'
import { markStationApprovalRead } from '@/api/device/station'
import router from '@/router'
import dayjs from 'dayjs'
import TablePagination from '@/components/TablePagination/index.vue'
import todoReportIcon from '@/assets/icons/svg/toto-report.svg'
import { checkRole } from '@/utils/permission.js'


const valueStyle = {
  fontSize: '30px',
}

function goStationsByStatus(statusQuery) {
  router.push({
    path: '/it-operations/multi/stations',
    query: { status: statusQuery },
  })
}
const dialogVisible = ref(false)
const orderDetail = ref({})

function onOpenOrderDetail(order) {
  orderDetail.value = order
  dialogVisible.value = true
}


const activeTab = ref('tab1')
const tabs = ref([
  {
    value: 'tab1',
    name: '类型1',
  },
  {
    value: 'tab2',
    name: '类型2',
  },
  {
    value: 'tab3',
    name: '类型3',
  },
])

const staticData = ref({
  alarm: {
    seriousFaultNum: 0,
    faultNum: 0,
    alarmNum: 0,
    promptNum: 0,
  },
  station: {
    notPutInto: 0,
    pendingReview: 0,
    putInto: 0,
    stopPutInto: 0,
  },
})

// 告警总数
const totalAlarmNum = computed(() => {
  const alarm = staticData.value.alarm
  if (!alarm) return undefined
  const sum = (alarm.seriousFaultNum ?? 0) + (alarm.faultNum ?? 0) + (alarm.alarmNum ?? 0) + (alarm.promptNum ?? 0)
  return Number.isFinite(sum) ? sum : undefined
})

// 电站总数 = 已投运 + 未投运 + 暂停运营
const totalStationNum = computed(() => {
  const station = staticData.value.station
  if (!station) return undefined
  const sum = (station.putInto ?? 0) + (station.notPutInto ?? 0) + (station.stopPutInto ?? 0)
  return Number.isFinite(sum) ? sum : undefined
})

async function fetchStationData() {
  try {
    const res = await api.queryStatisticalData()
    staticData.value = res.data
    console.log('获取电站数据成功:', res.data)
  } catch (error) {
    console.error('获取电站数据失败:', error)
  }
}

const page = ref(1)
const pageSize = ref(10)
const total = ref(0)


const searchKeyword = ref('')
const orderLoading = ref(false)
const orderList = ref([])
async function fetchOrderList() {
  const params = {
    pageNum: page.value,
    pageSize: pageSize.value,
  }
  orderLoading.value = true

  try {
    const res = await api.getWorkOrderPage(params)
    orderList.value = res.rows || []
    total.value = res.total
    console.log('获取工单列表成功:', res)
  } catch (error) {
    console.error('获取工单列表失败:', error)
  } finally {
    orderLoading.value = false
  }
}

fetchStationData()
fetchOrderList()


/* -------------------- 运营待办事项 -------------------- */
const omTodoLoading = ref(false)
const omTodoList = ref([])

// 每 6 条一页，用于 el-carousel 分页展示，底部显示蓝色指示器
function groupBySize(list = [], size = 6) {
  const result = []
  for (let i = 0; i < list.length; i += size) {
    result.push(list.slice(i, i + size))
  }
  return result
}

const groupedOmTodoList = computed(() => groupBySize(omTodoList.value))

// jd-develop / jd-project 视角
const isEngineeringRole = computed(() => checkRole(['jd-develop', 'jd-project']))

// 电站申请卡片文案：
// - 工程类角色（jd-develop / jd-project）：已通过 / 已被驳回
// - 其它（jd-support）：待处理的建站申请
function getOmTodoText(task) {
  if (isEngineeringRole.value) {
    const statusText = task?.status === 1 ? '已通过' : '已被驳回'
    return `${task?.stationName ?? ''}审批${statusText}，请注意查看！`
  }
  return `${task?.stationName ?? ''}建站申请，请及时处理！`
}

function formatOmTodoTime(time) {
  if (!time) return ''
  const d = dayjs(time)
  return d.isValid() ? d.format('YYYY-MM-DD HH:mm:ss') : String(time)
}

async function fetchOmTodoList() {
  omTodoLoading.value = true
  try {
    // jd-develop / jd-project 走「已审批」接口，前端过滤 status !== 0 且 applicantRead === 0
    // jd-support（及其它默认情况）走原「待办」接口
    // 同时命中时工程类优先（与 /personal/stations 保持一致）
    if (checkRole(['jd-develop', 'jd-project'])) {
      const res = await api.getApprovedStationList({ pageNum: 1, pageSize: 999 })
      const rows = res?.rows || []
      omTodoList.value = rows.filter(row => row.status !== 0 && row.applicantRead === 0)
    } else {
      const res = await api.getOMTodoList()
      omTodoList.value = res?.rows || []
    }
  } catch (error) {
    console.error('获取电站申请列表失败:', error)
    omTodoList.value = []
  } finally {
    omTodoLoading.value = false
  }
}

/** 电站申请「详情」：跳转到审批详情页，默认落到「基本信息」步骤
 *  - 工程类角色（jd-develop / jd-project）看到的是「自己申请的电站审批结果」，属于申请者视角，
 *    需带 role=creator，以便已驳回电站显示「提交」按钮（详见 approve/index.vue canResubmit）
 *    同时若该条 applicantRead === 0（未读），进入前调接口置为已读
 *  - 其它角色（jd-support）是审批者视角，保持原逻辑（显示驳回/投运按钮）
 */
function onOpenOmTodoDetail(task) {
  const stationId = task?.stationId ?? task?.bizId
  if (stationId == null) return
  const query = { stationId, step: 'basic' }
  if (isEngineeringRole.value) {
    query.role = 'creator'
    if (task?.applicantRead === 0 && task?.id != null) {
      markStationApprovalRead(task.id).catch((e) => console.error('标记审批已读失败', e))
    }
  }
  router.push({
    path: '/approve',
    query,
  })
}

fetchOmTodoList()
</script>

<style scoped lang="scss">
.gm-page {
  overflow-x: hidden;
  overflow-y: auto;
}

.om-table-wrap {
  flex: 1;
  overflow-x: auto;
  overflow-y: auto;
  scrollbar-gutter: stable;
  min-height: 200px;
}

.om-table-inner {
  min-width: 900px;
}

.om-table {
  width: 100%;
  table-layout: fixed;
  white-space: nowrap;
}

.om-table th,
.om-table td {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.om-workorder-card {
  display: flex;
  flex-direction: column;
  min-height: 300px;
}

.workbench-right {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

@media (max-width: 1400px),
(max-height: 800px) {
  .om-table-wrap {
    overflow-x: auto;
    overflow-y: hidden;
    max-height: calc(100vh - 400px);
  }

  .om-table-inner {
    min-width: 900px;
    overflow: visible;
  }

  .om-table {
    min-width: 900px;
    border-collapse: collapse;
  }

  .gm-card--alarm .gm-border {
    flex-direction: row !important;
    gap: 12px;
    align-items: stretch;
    flex-wrap: nowrap;
    justify-content: stretch;
  }

  .alarm-total {
    width: 45%;
    min-width: 120px;
    flex-shrink: 0;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 12px;
    background: url(./icon-alarm.png) no-repeat center center;
    background-size: cover;
    border-radius: 8px;
  }

  .alarm-total-card {
    position: static !important;
    text-align: center;
    z-index: 1;

    :deep(.data-card__title) {
      color: #fff !important;
    }

    :deep(.data-card__value) {
      color: #fff !important;
    }
  }

  .alarm-total img {
    display: none;
  }

  .gm-card--alarm .gm-border>div:last-child {
    flex: 1;
    display: grid !important;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
    padding: 0;
    min-width: 0;
  }

  .gm-card--alarm .ticket-card--alarm {
    min-width: 0;
    padding: 8px;
  }

  .d-flex.ga-4.flex-grow-1 {
    display: grid !important;
    grid-template-columns: minmax(300px, 2fr) minmax(250px, 1fr);
    grid-template-rows: minmax(0, 1fr);
    gap: 10px;
    align-items: stretch;
  }

  .d-flex.ga-4.flex-grow-1>div:first-child {
    display: flex;
    flex-direction: column;
    min-height: 0;
  }

  .d-flex.ga-4.flex-grow-1>div:first-child>.om-workorder-card {
    flex: 1;
    min-height: 0;
  }

  .d-flex.ga-4.flex-grow-1>div:last-child {
    display: flex;
    flex-direction: column;
    min-height: 0;
    position: static !important;
  }

  .d-flex.ga-4.flex-grow-1>div:last-child>div {
    position: static !important;
    display: flex;
    flex-direction: column;
  }

  .d-flex.ga-4.flex-grow-1>div:last-child>div>.gm-card:last-child {
    flex: 0 0 auto;
    min-height: 0;
  }

  .d-flex.ga-4.flex-grow-1>div:last-child>div>.om-todo-card {
    flex: 1;
    min-height: 0;
  }
}

@media (min-width: 1401px) and (max-width: 1919px) {
  .om-table-wrap {
    overflow-x: auto;
    overflow-y: hidden;
    max-height: calc(100vh - 420px);
  }

  .om-table-inner {
    min-width: 900px;
    overflow: visible;
  }

  .om-table {
    min-width: 900px;
    border-collapse: collapse;
  }

  .gm-card--alarm .gm-border {
    flex-direction: row;
    gap: 12px;
  }

  .alarm-total {
    width: auto;
    justify-content: flex-start;
    padding: 0;
  }

  .alarm-total-card {
    position: absolute;
    left: 16px;
    top: 16px;
  }

  .alarm-total img {
    display: block;
  }

  .d-flex.ga-4.flex-grow-1 {
    display: grid !important;
    grid-template-columns: minmax(400px, 2fr) minmax(300px, 1fr);
    grid-template-rows: minmax(0, 1fr);
    gap: 16px;
    align-items: stretch;
  }

  .d-flex.ga-4.flex-grow-1>div:first-child {
    display: flex;
    flex-direction: column;
    min-height: 0;
  }

  .d-flex.ga-4.flex-grow-1>div:first-child>.om-workorder-card {
    flex: 1;
    min-height: 0;
  }

  .d-flex.ga-4.flex-grow-1>div:last-child {
    display: flex;
    flex-direction: column;
    min-height: 0;
    position: static !important;
  }

  .d-flex.ga-4.flex-grow-1>div:last-child>div {
    position: static !important;
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .d-flex.ga-4.flex-grow-1>div:last-child>div>.gm-card:last-child {
    flex: 0 0 auto;
    min-height: 0;
  }

  .d-flex.ga-4.flex-grow-1>div:last-child>div>.om-todo-card {
    flex: 1;
    min-height: 0;
  }
}

@media (min-width: 1920px) {
  .om-table-wrap {
    overflow-x: auto;
    overflow-y: hidden;
    max-height: calc(100vh - 450px);
  }

  .om-table-inner {
    min-width: 100%;
    overflow: visible;
  }

  .om-table {
    min-width: 100%;
    border-collapse: collapse;
  }

  .gm-card--alarm .gm-border {
    flex-direction: row;
    gap: 16px;
  }

  .alarm-total {
    width: auto;
    justify-content: flex-start;
    padding: 0;
  }

  .alarm-total-card {
    position: absolute;
    left: 16px;
    top: 16px;
  }

  .alarm-total img {
    display: block;
  }

  .d-flex.ga-4.flex-grow-1 {
    display: grid !important;
    grid-template-columns: minmax(500px, 2fr) minmax(350px, 1fr);
    grid-template-rows: minmax(0, 1fr);
    gap: 20px;
    align-items: stretch;
  }

  .d-flex.ga-4.flex-grow-1>div:first-child {
    display: flex;
    flex-direction: column;
    min-height: 0;
  }

  .d-flex.ga-4.flex-grow-1>div:first-child>.om-workorder-card {
    flex: 1;
    min-height: 0;
  }

  .d-flex.ga-4.flex-grow-1>div:last-child {
    display: flex;
    flex-direction: column;
    min-height: 0;
    position: static !important;
  }

  .d-flex.ga-4.flex-grow-1>div:last-child>div {
    position: static !important;
    display: flex;
    flex-direction: column;
  }

  .d-flex.ga-4.flex-grow-1>div:last-child>div>.gm-card:last-child {
    flex: 0 0 auto;
    min-height: 0;
  }

  .d-flex.ga-4.flex-grow-1>div:last-child>div>.om-todo-card {
    flex: 1;
    min-height: 0;
  }
}

.alarm-total {
  position: relative;
  display: flex;
  align-items: center;
}

.alarm-total-card {
  position: absolute;
  left: 16px;
  top: 16px;

  :deep(.data-card__title) {
    color: #fff;
  }
}

.station-stat-card {
  flex: 1;
  min-width: 0;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 8px;
  text-align: inherit;
  transition: box-shadow 0.2s ease, transform 0.15s ease;

  &:hover {
    box-shadow: 0 4px 14px rgba(47, 89, 235, 0.12);
    transform: translateY(-1px);
  }

  &:focus-visible {
    outline: 2px solid #2f59eb;
    outline-offset: 2px;
  }
}

.ticket-card {
  background: #F3F2FF;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 8px;
    background: #fff;
    pointer-events: none;
    clip-path: polygon(46% 0, 53% 0, 52% 100%, 47% 100%);
  }

  &::before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 8px;
    background: #fff;
    pointer-events: none;
    clip-path: polygon(47% 0, 52% 0, 53% 100%, 46% 100%);
  }
}

.gm-card--alarm {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.63) 0%, rgba(255, 255, 255, 0.42) 104.73%);
}

.ticket-card--alarm {
  background: #F3F2FF;
  border-radius: 8px;

  &::after {
    height: 6px;
    clip-path: polygon(42% 0, 60% 0, 58% 100%, 44% 100%);
  }

  &::before {
    height: 6px;
    clip-path: polygon(44% 0, 58% 0, 60% 100%, 42% 100%);
  }

  :deep(.data-card__value) {
    text-align: center;
  }
}


.faq-item {
  font-size: 14px;
  font-weight: normal;
  font-family: 'HarmonyOS Sans SC';
  cursor: pointer;

  &:hover {
    color: var(--color-primary);
    text-decoration: underline;
  }
}


.faq-question {
  height: 40px;
  display: flex;
  align-items: center;
  border-color: #2655F166;
  padding: 0 8px;
  transition: border-color 0.3s ease-in-out;


  &:focus-within {
    border-color: var(--color-primary);
  }
}

.faq-question-input {
  flex-grow: 1;
  font-size: 14px;
  outline: none;
}

/* 运营待办事项 */
.om-todo-card {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
}

.om-todo-tabs {
  font-size: 14px;
  font-weight: normal;
  font-family: 'HarmonyOS Sans SC';
}

.om-todo-tabs--disabled {
  pointer-events: none;
  filter: grayscale(0.5) opacity(0.5);
}

.om-todo-tab {
  cursor: pointer;
  padding: 6px 8px;
  border-radius: 6px;
}

.om-todo-tab.active {
  color: var(--color-primary);
}

.om-todo-list {
  min-height: 288px;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
}

.om-todo-list :deep(.el-carousel) {
  flex: 1 1 auto;
  min-height: 288px;
}

.om-todo-list :deep(.el-carousel__container) {
  height: 100% !important;
}

.om-todo-empty {
  min-height: 180px;
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 14px;
}

.om-todo-item {
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 14px;
  padding: 0 12px;
  height: 48px;
}

.om-todo-item:hover {
  background: linear-gradient(90deg, rgba(38, 85, 241, 0.04) 0%, rgba(85, 7, 253, 0.04) 100%);
}

.om-todo-item+.om-todo-item {
  border-top: 1px solid #edf2f6;
}

.om-todo-icon {
  display: flex;
  align-items: center;
}

.om-todo-title {
  font-weight: 500;
}

.om-todo-info {
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
}

.om-todo-time {
  color: #2E2E2E80;
}

.om-todo-actions {
  margin-left: auto;
}

:deep(.el-carousel__button) {
  background-color: var(--color-primary);
  width: 20px;
  height: 3px;
  border-radius: 2px;
}

:deep(.el-carousel__indicators--horizontal) {
  bottom: -16px;
  margin: 0;
  padding: 0;
  row-gap: 0;
}
</style>
